import { render, staticRenderFns } from "./WizardPage3.vue?vue&type=template&id=5c33a624"
import script from "./WizardPage3.vue?vue&type=script&lang=js"
export * from "./WizardPage3.vue?vue&type=script&lang=js"
import style0 from "./WizardPage3.vue?vue&type=style&index=0&id=5c33a624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
